import * as React from 'react';
import {cn} from '../../lib/cn';
import {Drawer, DrawerContent, DrawerDescription, DrawerTitle} from '../../drawer';

type AirbnbDateRangePopoverProps = {
  isOpen: boolean;
  isMobile: boolean;
  openDirection: 'up' | 'down';
  drawerTitle: string;
  drawerDescription: string;
  onClose: () => void;
  children: React.ReactNode;
};

function AirbnbDateRangePopover({
  isOpen,
  isMobile,
  openDirection,
  drawerTitle,
  drawerDescription,
  onClose,
  children,
}: AirbnbDateRangePopoverProps) {
  if (!isOpen) return null;

  if (isMobile) {
    return (
      <Drawer
        open={isOpen}
        onOpenChange={next => {
          if (!next) onClose();
        }}
      >
        <DrawerContent
          onClose={onClose}
          lockScroll={false}
          className="max-h-[calc(100vh-1rem)]"
        >
          <DrawerTitle className="sr-only">{drawerTitle}</DrawerTitle>
          <DrawerDescription className="sr-only">{drawerDescription}</DrawerDescription>
          <div className="flex items-start justify-center overflow-x-auto px-2 pb-4 pt-1">
            {children}
          </div>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <div
      className={cn(
        'absolute left-0 z-30 w-max overflow-hidden border shadow-[0_8px_28px_0_rgba(0,0,0,0.12)]',
        'rounded-[var(--calendar-popover-radius,24px)] border-[var(--calendar-popover-border,var(--chekin-airbnb-border-soft))] bg-[var(--calendar-popover-bg,#fff)]',
        openDirection === 'up' ? 'bottom-full mb-2' : 'top-full mt-2',
      )}
    >
      {children}
    </div>
  );
}

export {AirbnbDateRangePopover};
export type {AirbnbDateRangePopoverProps};
